import { useSession } from "providers/SessionProvider";
import { EditUserProfile } from "views/foundation/user/Home/EditProfile/EditUserProfile";

////////////////////////////////////////////////////////////////////////////

/**
 * Edição do Perfil do próprio usuário
 * @param props
 */
export const EditOwnProfile: React.FC = () => {

    const session = useSession();

    return (
        <EditUserProfile userId={session.user.userId} />
    );
};
